/**
 * Title panel for the Jobs list page.
 */
import {TargetBlank} from '@wandb/weave/common/util/links';
import {Button} from '@wandb/weave/components/Button';
import React from 'react';

import DocUrls from '../../../util/doc_urls';
import * as S from './JobsHeader.styles';

export const JobsHeader: React.FC<{}> = () => {
  return (
    <S.Header>
      <S.Title>Jobs</S.Title>
      <S.Spacer />
      <TargetBlank href={DocUrls.launchJobsCreate}>
        <Button size="large" variant="secondary" icon="documentation">
          Jobs documentation
        </Button>
      </TargetBlank>
    </S.Header>
  );
};
